import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sliceGenericPrefix',
})
export class SliceGenericPrefixPipe implements PipeTransform {
  transform(value: string, prefix: string): string {
    return value.slice(prefix.length);
  }
}
